// STYLE
import s from "./flashingDots.module.scss";

export default function FlashingDots() {
  return (
    <div className={s.dot_flashing}></div>
  );
}
